export default __webpack_public_path__ + "static/parallaxImage-8d4cfdccea343deac845381e044f3ac2.png";